module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = 450
// module chunks = 0